import { ReactNode } from 'react'
import {
  BarChart,
  Category,
  Dashboard,
  Description,
  EditNote,
  Home,
  MenuBook,
  People,
  Storage,
  Terminal,
} from '@mui/icons-material'
import { com } from '@eidu/form'
import { KnownKindKey, getKnownKindKey } from '../../domain/kindRegistry'
import { ViewConfig } from './kinds/KindPages'
import DefaultViewPage from './kinds/default/DefaultViewPage'
import DefaultEditPage from './kinds/default/DefaultEditPage'
import UserViewPage from './kinds/user/UserViewPage'
import UserEditPage from './kinds/user/UserEditPage'
import LearningUnitViewPage from './kinds/learning-unit/LearningUnitViewPage'
import LearningUnitEditPage from './kinds/learning-unit/LearningUnitEditPage'
import FormViewPage from './kinds/form/FormViewPage'
import FormEditPage from './kinds/form/FormEditPage'
import AssetViewPage from './kinds/asset/AssetViewPage'
import AssetEditPage from './kinds/asset/AssetEditPage'
import RuntimeViewPage from './kinds/runtime/RuntimeViewPage'
import RuntimeEditPage from './kinds/runtime/RuntimeEditPage'
import EntityTypeKind = com.eidu.sharedlib.entity.type.EntityTypeKind

type KindViewConfig = {
  icon: ReactNode
  viewConfig: ViewConfig
}

const defaultPageConfig: ViewConfig = { ViewPage: DefaultViewPage, EditPage: DefaultEditPage }
const assetPageConfig: ViewConfig = { ViewPage: AssetViewPage, EditPage: AssetEditPage }

const kindViewRegistry: Record<KnownKindKey, KindViewConfig> = {
  User: { icon: <People />, viewConfig: { ViewPage: UserViewPage, EditPage: UserEditPage } },
  School: { icon: <Home />, viewConfig: defaultPageConfig },
  Generic: { icon: <Category />, viewConfig: defaultPageConfig },
  LearningUnit: { icon: <MenuBook />, viewConfig: { ViewPage: LearningUnitViewPage, EditPage: LearningUnitEditPage } },
  Form: { icon: <Description />, viewConfig: { ViewPage: FormViewPage, EditPage: FormEditPage } },
  Dataset: { icon: <Storage />, viewConfig: assetPageConfig },
  Chart: { icon: <BarChart />, viewConfig: assetPageConfig },
  Dashboard: { icon: <Dashboard />, viewConfig: assetPageConfig },
  Runtime: { icon: <Terminal />, viewConfig: { ViewPage: RuntimeViewPage, EditPage: RuntimeEditPage } },
}

export const iconForEntityTypeKind = (kind: EntityTypeKind, fallbackIcon: ReactNode = <EditNote />): ReactNode => {
  const key = getKnownKindKey(kind)
  return key ? kindViewRegistry[key].icon : fallbackIcon
}

export const getKindPageConfig = (kind: EntityTypeKind): ViewConfig => {
  const key = getKnownKindKey(kind)
  return key ? kindViewRegistry[key].viewConfig : defaultPageConfig
}
